import { Table } from "antd";
import "@/assets/styles/custom_table.css";
import PropTypes from "prop-types";
import Column from "antd/es/table/Column";
import ArrowIcon from "@/assets/icons/web_Icons/arrows.svg";

const TransactionTable = ({ data }) => {
  // Return null if there's no data
  if (!data || data.length === 0) {
    return null;
  }

  return (
    <>
      {/* Table - Visible only on lg screens and up */}
      <div className="hidden lg:block">
        <Table dataSource={data} className="transaction-table">
          <>
            <Column
              title="ITEM"
              dataIndex="item"
              key="item"
              render={(_, { item }) => (
                <p className="text-regular text-black">{item}</p>
              )}
            />
            <Column
              title="QTY"
              dataIndex="quantity"
              key="quantity"
              render={(_, { quantity }) => (
                <p className="text-regular text-black">{quantity}</p>
              )}
            />
            <Column
              title=""
              dataIndex="options"
              key="options"
              render={() => (
                <img src={ArrowIcon} alt="More Image" className="w-[10px]" />
              )}
            />
            <Column
              title="PRICE (₦)"
              dataIndex="price"
              key="price"
              render={(_, { price }) => (
                <p className="text-regular text-black">{price}</p>
              )}
            />
            <Column
              title="TOTAL"
              dataIndex="totalPrice"
              key="totalPrice"
              render={(_, { totalPrice }) => (
                <p className="text-regular text-black">{totalPrice}</p>
              )}
            />
          </>
        </Table>
      </div>

      {/* Cards - Visible only on mobile (smaller than lg screens) */}
      <div className="flex flex-col gap-[30px] mb-10 lg:hidden">
        {data.map((item, index) => (
          <div
            key={index}
            className="flex items-center justify-between p-4 shadow-sm bg-secondary rounded-md">
            <div className="flex-1">
              <h3 className="text-bold text-darkGrey">{item.item}</h3>
            </div>
            <div className="flex items-center gap-8">
              <div className="text-center">
                <span className="font-medium text-bold text-darkGrey">
                  {item.quantity}
                </span>
              </div>
              <div className="text-right">
                <p className="text-regular text-darkGrey">₦{item.price}</p>
                <p className="text-gray-500 text-small">₦{item.totalPrice}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

TransactionTable.propTypes = {
  data: PropTypes.array,
};

export default TransactionTable;
